import { getApiError } from '@/utils/apiError';

interface MissingReasonItem { name?: string; sku?: string }

/**
 * TCR-2129 — lỗi 400 BE khi còn dòng CK khác chính sách thiếu lý do (BE tự tính, có thể khác FE).
 * `index` BE trả là vị trí dòng phía BE, KHÔNG phải vị trí giỏ FE ⇒ chỉ hiển thị tên/SKU.
 */
export function formatMissingReasonError(err: unknown): string | null {
  // Envelope chuẩn: response.data.error.details (getApiError); dự phòng response.data.details.
  const fromEnvelope = getApiError(err)?.details as { missing_reason_items?: unknown } | undefined;
  const fromBody = (err as { response?: { data?: { details?: { missing_reason_items?: unknown } } } } | null)
    ?.response?.data?.details;
  const list = fromEnvelope?.missing_reason_items ?? fromBody?.missing_reason_items;
  if (!Array.isArray(list) || list.length === 0) return null;
  const names = (list as MissingReasonItem[]).map((i) => i.name || i.sku).join(', ');
  return `Còn ${list.length} dòng chiết khấu khác chính sách chưa nhập lý do: ${names}`;
}
